import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter2() {
  const hyperlinkData = [
    {
      href: 'https://www.destinationtoronto.com/restaurants/michelin/',
      copy: 'Toronto',
      label: 'Visit The MICHELIN Guide Toronto'
    },
    {
      href: 'https://www.destinationvancouver.com/restaurants/michelin/',
      copy: 'Vancouver',
      label: 'Visit The MICHELIN Guide Vancouver'
    },
    {
      href: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/nova-scotia/',
      copy: 'chef Kia Damon eat her way through Nova Scotia',
      label: 'Visit Episode One, Explore Nova Scotia with Kia Damon'
    },
    {
      href: 'https://restaurantarvi.ca/',
      copy: 'Arvi',
      label: 'Visit Arvi homepage'
    },
    {
      href: 'https://restaurantleclan.com/',
      copy: 'Le Clan',
      label: 'Visit Le Clan homepage'
    },
    {
      href: 'https://www.restaurantalentours.com/',
      copy: 'Restaurant Alentours',
      label: 'Visit Restaurant Alentours homepage'
    },
    {
      href: 'https://www.mtl.org/en',
      copy: 'Montréal',
      label: 'Visit Tourisme Montréal homepage'
    }
  ];
  return (
    <section className="chapter">
      <h2 className="chapter__head">Québec City</h2>
      <h3 className="chapter__subhead">A haven for foodies</h3>
      <p className="chapter__paragraph">
        Founded in 1608 by European settlers—but home to Indigenous communities like the Abenaki,
        Algonquin, Attikamekw, Cree, Huron-Wendat, Mohawk, Malecites, Innus, Mi'kmaq and Naskapi
        since time immemorial—the area around Québec City was dubbed “Nouvelle-France” until the
        British conquest of 1759. Shaped by the cerulean blue waterways of the St. Lawrence River,
        the city and province retain its French culture to this day, featuring North America’s only
        region with a French-speaking majority. There’s also hearty cuisine, neoclassical
        architecture (including the oldest church in Canada), and lively year-round festivals like
        the Festival d’été de Québec (Canada’s biggest outdoor musical event) and the
        family-friendly Québec Winter Carnival.
      </p>
      <p className="chapter__paragraph">
        While <Hyperlink hyperlinkData={hyperlinkData[0]} /> and{' '}
        <Hyperlink hyperlinkData={hyperlinkData[1]} /> recently won several long-awaited MICHELIN
        stars, they’re not the only foodie destinations in Canada (see{' '}
        <Hyperlink hyperlinkData={hyperlinkData[2]} />
        ). You might visit Québec City for its historic old town and fortification walls, but you’ll
        also find a dining scene worth indulging in. New restaurants like{' '}
        <Hyperlink hyperlinkData={hyperlinkData[3]} />,{' '}
        <Hyperlink hyperlinkData={hyperlinkData[4]} />, and{' '}
        <Hyperlink hyperlinkData={hyperlinkData[5]} /> feature foraged ingredients, local cheeses,
        contemporary micro-brews, and fresh produce sourced from surrounding counties and even the
        nearby island Île d'Orléans. Those yearning for even more culinary experiences can visit{' '}
        <Hyperlink hyperlinkData={hyperlinkData[6]} />, only a three-hour drive away—just don’t
        forget to stop at a casse-croûte, Québec’s answer to a roadside snack shack, for some
        classic poutine (french fries and cheese curds topped with gravy).
      </p>
    </section>
  );
}

export default Chapter2;
